"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProductFlag_1 = require("./ProductFlag");
/**
 * Product represents internal product of the company. Some information,
 * such as its name, description, are updated within nighttime imports.
 *
 * @author JMe
 */


var Product =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Product, _DomainObject_1$Domai);

  /**
   * Constructs product instance.
   *
   * @param id the internal id of product
   * @param externalId the external id of product, i.e. from source data, is used for pairing during data import
   * @param numericId This ID is intended for systems (e.g. Yieldigo) that need numeric IDs.
   * @param name
   * @param familyId reference to family to which product belong, it is here for query optimization (information about products in family
   *        is mainly part of FamilyBinding of Family)
   * @param description
   * @param eans List of EANs linked to product. EANs don't have to be valid or active.
   * @param categoryIds List of product categories. The first one is lowest category, the last one is root.
   * @param productSensitivityId ID of a price sensitivity group the product belongs to.
   * @param tierId Tier assigned to product. Null, if the product belongs to a family. The tier is taken from the family then.
   * @param flags
   * @param calibratedProductId a variant of a product (the calibrated product is of the same type)
   * @param predecessorId a product can have a predecessor
   * @param classification may be used to help filtering products according to company custom needs
   * @param dimensions
   * @param expiration expiration in days (null, 999 or 0 means unlimited expiration)
   * @param supplierId id of preferred supplier within national zone (null means no preferred supplier has been found, most probably
   *        product has no suppliers)
   * @param supplierIds list of active suppliers of this product within national zone (preferred excluded)
   * @param active simple flag that determines whether product is active or not
   * @param measureUnitId measure unit id which cannot be changed in time. If not otherwise stated, all data (such as within transactions,
   *        supplies, ...) are related to this unit.
   * @param packageSize weight/volume for unit price calculation
   * @param numberOfProductBindings the number of approved bindings with competitor products, null for newly imported product before
   *        first pairing
   * @param newlyListedIntervalStart date the product was imported for the first time and marked as newly listed in a source db
   * @param newlyListedIntervalEnd date the product ceased to be marked as newly listed in a source db
   */
  function Product(id, externalId, numericId, name, familyId, description, eans, categoryIds, productSensitivityId, tierId, flags, calibratedProductId, predecessorId, classification, dimensions, expiration, supplierId, supplierIds, active, measureUnitId, packageSize, numberOfProductBindings, newlyListedIntervalStart, newlyListedIntervalEnd) {
    var _this;

    _classCallCheck(this, Product);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Product).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.numericId = numericId;
    _this.name = name;
    _this.familyId = familyId;
    _this.description = description;
    _this.eans = eans;
    _this.categoryIds = categoryIds;
    _this.productSensitivityId = productSensitivityId;
    _this.tierId = tierId;
    _this.flags = flags;
    _this.calibratedProductId = calibratedProductId;
    _this.predecessorId = predecessorId;
    _this.classification = classification;
    _this.dimensions = dimensions;
    _this.expiration = expiration;
    _this.supplierId = supplierId;
    _this.supplierIds = supplierIds;
    _this.active = active;
    _this.measureUnitId = measureUnitId;
    _this.packageSize = packageSize;
    _this.numberOfProductBindings = numberOfProductBindings;
    _this.newlyListedIntervalStart = newlyListedIntervalStart;
    _this.newlyListedIntervalEnd = newlyListedIntervalEnd;
    return _this;
  }
  /**
   * @returns true if product has unlimited expiration, false otherwise
   */


  _createClass(Product, [{
    key: "hasUnlimitedExpiration",
    value: function hasUnlimitedExpiration() {
      return !this.expiration || this.expiration === 0 || this.expiration === 999;
    }
  }], [{
    key: "findCategoryIdWithLevel",
    value: function findCategoryIdWithLevel(productCategoryIds, level) {
      // LOG-3564 - some products have only 5 levels of categories
      if (productCategoryIds.size === 0) {
        return null;
      }

      if (productCategoryIds.size >= level) {
        var idx = productCategoryIds.size - level;
        return productCategoryIds.get(idx, null);
      }

      return null;
    }
  }]);

  return Product;
}(DomainObject_1.DomainObject);

exports.Product = Product;
Product.PRODUCTS_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.Product; // tslint:disable-next-line:member-ordering

Product.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Product.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    numericId: builder.num('numericId'),
    name: builder.str('name'),
    familyId: builder.opt(builder.str('familyId')),
    description: builder.opt(builder.str('description')),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    eans: builder.listOf(builder.data('ean', {
      value: builder.str('value'),
      dateFrom: builder.opt(builder.date('dateFrom')),
      dateTo: builder.opt(builder.date('dateTo')),
      active: builder.opt(builder.bool('active')),
      eanDescription: builder.opt(builder.str('eanDescription'))
    })),
    flags: builder.flags('flags', ProductFlag_1.ProductFlag),
    productSensitivityId: builder.str('productSensitivityId'),
    tierId: builder.opt(builder.id('tierId')),
    calibratedProductId: builder.opt(builder.str('calibratedProductId')),
    predecessorId: builder.opt(builder.str('predecessorId')),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: Product.name + '_classification'
    })),
    dimensions: builder.opt(builder.data('dimensions', {
      width: builder.opt(builder.bigNum('width')),
      height: builder.opt(builder.bigNum('height')),
      weight: builder.opt(builder.bigNum('weight')),
      length: builder.opt(builder.bigNum('length'))
    })),
    expiration: builder.opt(builder.num('expiration')),
    supplierId: builder.opt(builder.id('supplierId')),
    supplierIds: builder.listOf(builder.id('supplierIds')),
    active: builder.bool('active'),
    measureUnitId: builder.str('measureUnitId'),
    packageSize: builder.data('packageSize', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }),
    numberOfProductBindings: builder.opt(builder.num('numberOfProductBindings')),
    newlyListedIntervalStart: builder.opt(builder.date('newlyListedIntervalStart', DateParser_1.DateParser.ISO_PATTERN)),
    newlyListedIntervalEnd: builder.opt(builder.date('newlyListedIntervalEnd', DateParser_1.DateParser.ISO_PATTERN))
  };
}();